// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--tKIeD","BodyContainerText":"_BodyContainerText--LIvT5","WarningIcon":"_WarningIcon--v4Dkk","Heading":"_Heading--I8I0s"};